/**
 * UI timing constants for consistent user experience
 */

/**
 * Debounce delay values in milliseconds
 * Use these constants to ensure consistent debounce timing across the application
 */
/**
 * Breakpoint (px) at which the sidebar causes stats to wrap to two rows
 */
export const SIDEBAR_TWO_ROW_BREAKPOINT_PX = 1440;

export const DEBOUNCE_DELAY = {
  /** Short delay for quick interactions (300ms) */
  SHORT: 300,
  /** Default delay for standard inputs (500ms) */
  DEFAULT: 500,
  /** Long delay for expensive operations (600ms) */
  LONG: 600,
} as const;
